export default __webpack_public_path__ + "static/media/contact.efb0ae40.jpg";